import IconDemo from './IconDemo'

export default IconDemo
// eslint-disable-next-line import/export
export * from './IconDemo'
